module.exports = __webpack_public_path__ + "img/uv_3.57fa950d.png";